import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table,
    Alert
} from "reactstrap";
import ReactPaginate from 'react-paginate';
import { useLocation, useNavigate } from "react-router-dom";
import { apiService } from '../../constants/ApiService';
import ItemRateMaster from '../ItemRate/ItemRateMaster';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import NoDataFound from '../../constants/NoDataFound';


const Party = () => {


    //----------- REDUCE TOOLKIT -------
    const vendorState = useSelector((state) => state.vendorState);
    const branchState = useSelector((state) => state.branchState);
    const sessionData = useSelector((state) => state.sessionState);
    const [errorMessage, setErrorMessage] = useState({});

    const { user } = useSelector((state) => state.authState);

    const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
        useVendorBranch(user);

    const [selectionData, setSelectionData] = useState({
        vendor_id: "",
        branch_id: "",
    });



    const navigate = useNavigate();
    const [partyTable, setPartyTable] = useState([]);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination
    const location = useLocation();
    const [model, setModel] = useState("")


    const onHandleAddParty = () => {
        navigate("/addparty")
    }

    const onHandleSearchKeyItem = (e) => {
        const value = e.target.value;
        getPartyData(1, 10, value)
    }

    const onHandleEditParty = (id) => {
        let findArrayData = partyTable.find(e => e.id === id)
        navigate('/addparty', { state: { partyId: findArrayData.id } });
    }

    const onHandleDeleteParty = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/PartyMaster/delete?partyId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getPartyData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    };

    const getPartyData = async (page = 1, limit = 10, search = "", venderMstId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };


            // Build query string
            let queryParams = `/api/PartyMaster/allparty?pageNo=${page}&limit=${limit}&searchKey=${search}`;
            // if (selectedVendorId) {
            //     queryParams += `&venderMasterId=${selectedVendorId}`; // fixed var name
            // }


            const vendorId = selectionData.vendor_id || 0;
            const branchId = selectionData.branch_id || 0;
            queryParams += `&venderMasterId=${vendorId}`;

            queryParams += `&branchMasterId=${branchId}`;


            // if (selectedBranchId) {
            //     queryParams += `&branchMasterId=${selectedBranchId}`; // fixed var name
            // }

            const response = await apiService.get(queryParams, config);
            // const response = await apiService.get(`/api/PartyMaster/allparty?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setPartyTable(response.partyMasterDetailData)
                setTotalPage(response.totalPages)

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    const handlePageClick = (data) => {
        getPartyData(data.selected + 1)
    };


    useEffect(() => {
        const canLoad = conditionalDataLoad({
            hasMultiBranch,
            hasSingleBranch,
            isSuperAdmin,
            isAdmin,
            vendorId: selectionData.vendor_id,
            branchId: selectionData.branch_id,
        });

        if (canLoad) {
            getPartyData(1, 100, "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectionData, sessionData]);

    // useEffect(() => {
    //     getPartyData();
    // }, [!partyTable]);



    // get the current url for add the slug/ glag condition

    const [openItemRate, setopenItemRate] = useState(false)
    useEffect(() => {

        const { pathname } = location;
        if ('/party/item' == pathname) {
            setopenItemRate(true)
        } else {
            setopenItemRate(false)
        }

    }, [location.pathname])


    const [partName, setPartName] = useState("")
    const [partyId, setPartyId] = useState("")


    const goToItemRate = async (partyId) => {

        const foundParty = await partyTable.find((data) => data.id === partyId);
        // navigate("", { state: { partyId: foundParty.id, partyName: foundParty.name } })
        setPartName(foundParty.name)
        setPartyId(foundParty.id)
        setModel("item")
    }

    const backTOPartyMaster = () => {
        setModel("")
    }

    const gotoBusinessuserDetail = () => {
        navigate("/BussinessUserDetail")
    }



    // =======================  VENDER & BRANCH =================

    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [selectedBranchId, setSelectedBranchId] = useState("");

    // Handle vendor selection change
    const selectVendorFilter = (e) => {

        let value = e.target.value
        if (!value) {
            setSelectedVendorId(value);
            setSelectedBranchId("");
        } else {
            setSelectedVendorId(value);
            setSelectedBranchId("");
            getPartyData(1, 10, "", value)
        }
    };


    // Handle branch selection change
    const selectbranchFilter = (e) => {
        setSelectedBranchId(e.target.value);
    };

    // useEffect(() => {
    //     getPartyData(1, 10, "")
    // }, [selectedVendorId, selectedBranchId])

    const showVendorFilter =
        !selectedVendorId &&
        (vendorState?.vendors?.length === 0 || vendorState?.vendors?.length > 1);

    const showBranchFilter =
        !selectedBranchId &&
        (branchState?.branches?.length === 0 || branchState?.branches?.length > 1);



    useEffect(() => {

        if (user.user_profile != "superadmin" && selectedVendorId && selectedBranchId) {
            getPartyData(1, 10, "")
        } else if (user.user_profile == "superadmin") {
            getPartyData(1, 10, "")
        }

        if (vendorState.vendors.length == 1) {
            setSelectedVendorId(vendorState.vendors[0].id);
        }

        if (branchState.branches.length == 1) {
            setSelectedBranchId(branchState.branches[0].id);
        }
    }, [selectedVendorId, selectedBranchId])

    return (
        <>

            {model == "" ?
                <>
                    {!openItemRate && (
                        <div className="d-flex justify-content-end mb-3">
                            <Button color="primary" onClick={onHandleAddParty} className="d-flex align-items-center">
                                <i className="bi bi-plus-circle mr-2"></i> New Party
                            </Button>
                        </div>
                    )}


                    <VendorBranchSelector
                        user={user}
                        selectionData={selectionData}
                        setSelectionData={setSelectionData}
                        errorMessage={errorMessage}
                        accessButton={true}
                    />

                    {/* Party List Card */}
                    <Card className='bg-white pd-10 card-box mb-30'>
                        <CardTitle tag="h6" className="border-bottom p-3 mb-0 bg-white">


                            {/* Search Box Row */}
                            <Row> <Col sm={6} className="d-flex align-items-center">
                                <i className="bi bi-list me-2"></i>
                                <span className="fw-semibold"> Party List </span>
                            </Col>
                                <Col sm={6} className="ms-auto">
                                    <Input
                                        id="search"
                                        name="search"
                                        placeholder="Search..."
                                        type="text"
                                        onChange={(e) => onHandleSearchKeyItem(e)}
                                    />
                                </Col>
                            </Row>

                        </CardTitle>


                        <CardBody>
                            <div className="table-responsive">
                                <Table hover striped responsive>
                                    <thead className='bg-primary text-white'>
                                        <tr>
                                            <th>S.no.</th>
                                            {isSuperAdmin && <th>Branch/Vendor Name</th>}
                                            <th>Initial Code</th>
                                            <th>Party Name</th>
                                            {/* <th>Address</th> */}
                                            {/* <th>Mobile No.</th> */}
                                            {/* <th>Mobile No.</th>
                                            <th>Address</th>
                                            <th>Pincode</th> */}
                                            {openItemRate ?
                                                <>
                                                    <th> Item Rate</th>
                                                </>

                                                :
                                                <>
                                                    {/* <th>Edit</th> */}
                                                    {/* <th>Delete</th> */}
                                                </>
                                            }
                                            {/* <th>Business Card</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {partyTable.length > 0 ? partyTable.map((item, index) =>
                                            <>
                                                <tr key={index}>
                                                    {/* <th scope='row' >

                                                        <i data-toggle="tooltip" title="Click to Update Party" data-placement="bottom" className="bi bi-pencil mr-1 text-primary" style={{ cursor: "pointer" }} onClick={() => onHandleEditParty(item.id)} />
                                                    </th>
                                                    <th scope="row">{index + 1}</th> */}


                                                    <th scope="row">
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "start", flexDirection: "column" }}>
                                                            <span className='ms-2'>{item.id}</span>

                                                            <Button
                                                                color="warning"
                                                                className="me-0 ms-2"
                                                                size="sm"
                                                                onClick={() => onHandleEditParty(item.id)}
                                                            >
                                                                <p style={{ fontSize: 12, padding: 0, margin: 0, fontWeight: "bold" }}><i className="bi bi-pencil mr-1"></i>Edit</p>
                                                            </Button>

                                                        </div>
                                                    </th>


                                                    {(user.user_profile == "superadmin" || branchState.length) && <td> {item.branch_name} ***** <br></br>{item.vender_name}</td>}


                                                    <td>{item.initial_party_code}</td>
                                                    <td>{`${item.name} (${item.party_agr_code})`}</td>
                                                    {/* <td>{item.address}</td> */}
                                                    {/* <td>{item.party_group_category_name}</td> */}
                                                    {/* <td>{item.mobile_number}</td>
                                                    <td>{item.address}</td> */}
                                                    {openItemRate ?
                                                        <>
                                                            <td>
                                                                <Button color="success" size="bg" onClick={() => goToItemRate(item.id)}>
                                                                    Update Rate List
                                                                </Button>
                                                            </td>
                                                        </>
                                                        :
                                                        <>
                                                            {/* <td>
                                                                <Button color="warning" size="bg" onClick={() => onHandleEditParty(item.id)}>
                                                                    <i className="fas fa-edit"></i>
                                                                </Button>
                                                            </td> */}

                                                        </>
                                                    }
                                                    {/* <td>
                                                        <Button color="info" size="bg" onClick={() => gotoBusinessuserDetail()}>
                                                            Business Card
                                                        </Button>
                                                    </td> */}

                                                </tr>
                                            </>

                                        ) : 
                                        (<NoDataFound colSpan={isSuperAdmin ? 4 : 3} message=""/>)}
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                        <CardBody>
                            {/* <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={totalPage}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                            /> */}

                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageCount={totalPage} // still 4000
                                marginPagesDisplayed={1} // 1 page at start & end
                                pageRangeDisplayed={2}  // visible range around selected page
                                onPageChange={handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}

                                pageClassName={'page-item'}
                                pageLinkClassName={'page-link'}
                                previousClassName={'page-item'}
                                nextClassName={'page-item'}
                                previousLinkClassName={'page-link'}
                                nextLinkClassName={'page-link'}
                                breakClassName={'page-item'}
                                breakLinkClassName={'page-link'}
                            />
                        </CardBody>




                    </Card>
                </>
                :

                model == "item" ?

                    <ItemRateMaster partyId={partyId} partyName={partName} backButton={backTOPartyMaster} />
                    :
                    null
            }
        </>
    )

}


export default Party